module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "119772.png",
      "src": "OEBPS/image/119772.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader"
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter ")]), _c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "119801.png",
      "src": "OEBPS/image/119801.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("As I drove away from the house, a light mist fell on my windshield. I had a lot on my mind as I drove along the curvy roads. I followed a line of cars that were cautiously watching the slick pavement. There wasn’t a time when I traveled these roads that I didn’t think of that horrific accident near Sugar Creek Winery. I should never have agreed to go in the car with Nick when I knew he’d consumed a lot of wine. That collision took away someone’s life. I tried to block it out of my mind and concentrate instead on seeing Marc. I arrived at his condo around six. I just needed to freshen up.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“You look great as always,” Marc said sweetly, giving me a kiss. “We’re going to meet up with them at a restaurant called Prasino. I think you’ll like it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Where does this couple live?” I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“New York. We’re representing the husband’s company in a case here in St. Louis. We won’t talk business, I promise.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Sweetie, you should know by now that I can talk about almost anything. Before I forget, I wanted to tell you that I got a phone call from the woman who lives in my old apartment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Really? Why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“She was up in the attic and found a quilt top that had my name on it. Evidently Bertie had made it for me. It’s strange, but Jenny is a writer also and works for Concordia Publishing House. I’m meeting her next week. I can’t wait to see what my old place looks like.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I was in your neighborhood recently, and they did get that mess cleaned up from Rosie’s burned shop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Good! I’ll bet it looks so different with that building gone. I wonder what will happen in that space. I don’t think I’d know anyone in that neighborhood anymore.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, with mostly apartments around there, you know there will be turnover.” Marc glanced at his watch and said, “We need to be on our way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("The restaurant was in a newly-developed section of town called Streets of St. Charles. When we walked in, I admired the contemporary design, which featured lots of windows. When Marc told the hostess that we had reservations, we learned that the other couple was already seated.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("When we arrived at the table, Marc introduced me to a very attractive couple in their fifties named John and Sandra. Not a single smile was offered by either of them. They looked as though they were prepared for a business meeting. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Nice to meet you,” I said as I sat down.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("A waiter immediately took our drink orders. I waited for Marc to start the conversation. He told the couple a little about the restaurant, which came highly recommended, and that it was his first time to try it out. They nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I must tell you a little bit about Lily,” Marc said with a wide smile. “She lives about an hour from here in a little community called Augusta, Missouri. She has a clever antique and quilt shop in the center of town.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("They looked at me curiously, like I was from another planet.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh, how cute,” Sandra replied. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“It must be difficult being so far from life in the city,” John added.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Not really,” I responded with confidence. “I lived in St. Louis for many years, in the Italian neighborhood called The Hill, but I find the wine country quite beautiful and satisfying.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Are you referring to the neighborhood in St. Louis where they recently had a shooting reported on the news?” John asked. “Maybe it’s where the St. Louis mafia resides.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Everyone laughed quietly—everyone except me. “Not that I’m aware of,” I stated.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I think John was just being a bit sarcastic, Lily,” Marc explained. “I have to say, you will never find better Italian restaurants anywhere in the country. By the way, it’s where I met this girl.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Marc grinned, but the couple did not. They couldn’t have cared less.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“So, what do you do?” I asked Sandra.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I’m currently the fashion editor of a magazine, a subsidiary of ")]), _c('span', {
    staticClass: "dedication2"
  }, [_vm._v("Vogue")]), _c('span', {
    staticClass: "byline"
  }, [_vm._v(", in fact.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh, how interesting!” I responded. I wanted to crawl under the table as I thought of my simple little black dress.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, Lily has her own column in ")]), _c('span', {
    staticClass: "dedication2"
  }, [_vm._v("Spirit")]), _c('span', {
    staticClass: "byline"
  }, [_vm._v(" magazine,” Marc stated proudly. “She recently turned down a weekly newspaper column.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I’ve never heard of ")]), _c('span', {
    staticClass: "dedication2"
  }, [_vm._v("Spirit")]), _c('span', {
    staticClass: "byline"
  }, [_vm._v(" magazine,” Sandra countered. “What do you write about?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I took a generous swallow of merlot before answering. “I write about quilts, antiques, and community life in Augusta,” I stated. “I can choose what I write about, which is nice.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Really?” she asked in disbelief.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("As we began to order our food, John and Sandra lamented that the menu did not offer them many choices. It seemed that they adhered to a rather restrictive diet. I could sense Marc beginning to become frustrated with them. To rescue the situation a bit, I heard myself filling them in on the history of St. Charles. Getting little response from that, I asked, “John, are you a baseball fan like Marc?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("John chuckled. “Baseball must be a Midwest thing. Some of the guys at work like the Mets, however.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Marc and I took a trip to Cooperstown,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Cooperstown?” Sandra asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Marc graciously explained that Cooperstown is home to the National Baseball Hall of Fame and Museum, and John pretended to know what Marc was talking about. We managed to get through the meal, but I could tell that Sandra was bored to tears. Overall, Marc recovered from his earlier frustration and managed to converse with them better than I could, but he was probably used to this behavior from some of his clients. The good news of the night was that it ended early and Marc agreed to meet with John the next morning at the office. After they left the restaurant, Marc and I looked at each other and burst into laughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I’m so sorry, Lily,” Marc said. “I knew nothing about them personally.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, they don’t have to ruin the entire evening. I think there’s still time to enjoy dessert!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“You are my kind of girl, Lily,” Marc said, squeezing my hand. ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20ca0816","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/quilt-left-behind_split13.vue
// module id = 99
// module chunks = 0